import { render, staticRenderFns } from "./CommissionInput.vue?vue&type=template&id=b72740b6&scoped=true&"
import script from "./CommissionInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./CommissionInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CommissionInput.vue?vue&type=style&index=0&id=b72740b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72740b6",
  null
  
)

export default component.exports